import api from '@/helpers/constants/api/optimize';
import Vue from 'vue'
class OptimizeApi {
    /**获取机构（供货、要货、管辖机构等） */
    getOrganiztion(params) {
        return Vue.prototype.$api.post(api.GET_ORGANIZATION, params);
    }

    /**供货机构（供应商）下拉框 - 加载数据 */
    getSublevel(params) {
        return Vue.prototype.$api.post(api.GET_SUBLEVEL, params)
    }
    /**仓库下拉框 - 加载数据 */
    getwarehouse(params) {
        return Vue.prototype.$api.post(api.GET_WAREHOUSE, params)
    }
    /**类别下拉框或树节点分段加载 - 加载数据  */
    getCategory(params) {
        return Vue.prototype.$api.post(api.GET_CATEGORY, params)
    }
    /**类别下拉框或树节点分段加载 - 加载数据  */
    getBumen(params) {
        return Vue.prototype.$api.post(api.GET_BUMEN, params)
    }
    /**类别下拉框或树节点分段加载 - 加载数据  */
    getBiaoqian(params) {
        return Vue.prototype.$api.post(api.GET_BIAOQIAN, params)
    }
    /**类别下拉框或树节点分段加载 - 加载数据  */
    getYuanyin(params) {
        return Vue.prototype.$api.post(api.GET_YUANYIN, params)
    }
    /**类别下拉框或树节点分段加载 - 加载数据  */
    getWupin(params) {
        return Vue.prototype.$api.post(api.GET_WUPIN, params)
    }
    /**类别下拉框或树节点分段加载 - 加载数据  */
    getCaipin(params) {
        return Vue.prototype.$api.post(api.GET_CAIPIN, params)
    }
    /**类别下拉框或树节点分段加载 - 加载数据  */
    getWaixiaokehu(params) {
        return Vue.prototype.$api.post(api.GET_WAIXIAOKEHU, params)
    }
    getItems(params) {
        return Vue.prototype.$api.post(api.GET_ITEM, params)
    }
}

export default OptimizeApi;


// WEBPACK FOOTER //
// ./src/logics/api/optimize.js